export const apiOptions = [
    {label: 'Somente com API', value: true},
    {label: 'Somente sem API', value: false}
];
